<template>
  <div class="f_content">
    <div>
      <div class="data-fetch-error" v-show="dataFetchError">
        <p>Unable to fetch required data. Please try again.</p>
      </div>
    </div>

    <div class="employee-name">
      <router-link to="/employee">Employees >&nbsp;</router-link>
      <a>{{ profile.firstname }} {{ profile.lastname }}</a>
    </div>
    <div class="view-employee">
      <p>View Employee</p>
    </div>
    
    <div>
      <img
          
          @click="goBack"
          class="back-arrow"
          src="../../../assets/images/arrow.png"
        />
    </div>

    <div class="page-loader" v-show="pageLoading">
      <div>
        <PageLoader />
      </div>
    </div>

    <div class="row avatar" v-if="!pageLoading">
      <div>
        <div
          v-if="profile.is_active == 1 && employee.is_admin == 0"
          style="overflow: hidden"
        >
          <button
            class="btn btn-primary float-right deactivate"
            @click.prevent="deactivateUser()"
            v-show="!deActivating"
          >
            Deactivate employee
          </button>
          <div v-show="deActivating" class="deactivate-loader float-right">
            <BlueLoader />
          </div>
        </div>
      </div>

      <div
        v-if="profile.is_active == 0 && employee.is_admin == 0"
        style="overflow: hidden"
      >
        <button
          class="btn btn-primary float-right deactivate"
          @click.prevent="activateUser()"
          v-show="!deActivating"
        >
          Activate employee
        </button>
        <div v-show="deActivating" class="deactivate-loader float-right">
          <BlueLoader />
        </div>
      </div>

      <img
        class="img-fluid avatar__image"
        src="./../../../assets/style/images/boy.svg"
        alt="user avatar"
      />
      <div class="avatar__details">
        <h2>{{ profile.firstname }} {{ profile.lastname }}</h2>
        <p>{{ employee.designations ? employee.designations.name : "" }}</p>
      </div>
    </div>

    <div>
      <div class="error">
        <p v-if="dataSaveError">{{ dataSaveError }}</p>
        <div v-if="serverErrors">
          <p v-for="(value, name, index) in serverErrors" :key="index">
            {{ value[0] }}
          </p>
        </div>
      </div>
    </div>

    <div class="row middle-row" v-if="!pageLoading">
      <div class="f_width section" v-if="!pageLoading">
        <div class="d-flex justify-content-between section__head">
          <div class="d-flex align-items-center">
            <img src="./../../../assets/style/images/settings.svg" />
            <h2>Job and Pay</h2>
          </div>
          <span>
            <a
              @click.prevent="editJobPay = true"
              class="edit"
              v-if="!editJobPay && profile.is_active == 1"
            >
              <font-awesome-icon icon="edit" />edit
            </a>
            <a
              @click.prevent="editJobPay = false"
              class="edit"
              v-if="editJobPay"
            >
              <font-awesome-icon icon="times" />close edit
            </a>
          </span>
        </div>

        <div class="card">
          <div class="card-body card__top section__body">
            <div class="section__item section__item--border d-flex">
              <div class="f_width section__key">Staff ID:</div>
              <div class="f_width section__value" v-if="!editJobPay">
                {{ employee.staff_number }}
              </div>
              <div class="f_width section__value" v-else>
                <input class="form-control" v-model="employee.staff_number" />
              </div>
            </div>

            <div class="section__item--border">
              <div class="section__item section__item--pad d-flex">
                <div class="f_width section__key">Gross Pay:</div>
                <div class="f_width section__value">
                  &#x20A6;{{ grossPay | valueToCurrency }}
                  <br />
                  <a
                    @click.prevent="showSalaryBreakdown = true"
                    class="salary-breakdown-button"
                    v-if="!showSalaryBreakdown"
                  >
                    View salary breakdown
                    <font-awesome-icon icon="angle-down" />
                  </a>
                  <a
                    @click.prevent="showSalaryBreakdown = false"
                    class="salary-breakdown-button"
                    v-if="showSalaryBreakdown"
                  >
                    View less
                    <font-awesome-icon icon="angle-up" />
                  </a>
                </div>
              </div>

              <div class="breakdown" v-if="showSalaryBreakdown">
                <div>
                  <h5>Compensation</h5>
                </div>
                <div
                  class="section__item section__item--border d-flex"
                  v-for="(comp, index) in compensations"
                  :key="index"
                >
                  <div class="f_width section__key">{{ comp.name }}:</div>
                  <div class="f_width section__value" v-if="!editJobPay">
                    &#8358;
                    {{ comp.value | valueToCurrency }}
                  </div>
                  <div class="f_width section__value" v-else>
                    <input
                      class="form-control"
                      v-model="compensations[index].value"
                      @keyup="formatAmount('compensation', index)"
                    />
                  </div>
                </div>
              </div>

              <div class="breakdown" v-if="showSalaryBreakdown">
                <div>
                  <h5>Deductibles</h5>
                </div>
                <div
                  class="section__item section__item--border d-flex"
                  v-for="(ded, index) in deductibles"
                  :key="index"
                >
                  <div class="f_width section__key">{{ ded.name }}:</div>
                  <div class="f_width section__value" v-if="!editJobPay">
                    &#8358;
                    {{ ded.value | valueToCurrency }}
                  </div>
                  <div class="f_width section__value" v-else>
                    <input
                      class="form-control"
                      v-model="deductibles[index].value"
                      @keyup="formatAmount('deductible', index)"
                    />
                  </div>
                </div>
              </div>

              <div class="section__item d-flex">
                <div class="f_width section__key">Net Pay:</div>
                <div class="f_width section__value">
                  &#x20A6;{{ netPay | valueToCurrency }}
                </div>
              </div>
            </div>
            <div class="section__item--border">
              <div
                class="section__item section__item--border section-error"
                v-if="bankInfoError"
              >
                {{ bankInfoError }}
              </div>

              <div class="section__item section__item--pad d-flex">
                <div class="f_width section__key">Bank:</div>
                <div class="f_width section__value" v-if="!editJobPay">
                  <span>{{
                    employee.bank_account_bank
                      ? employee.bank_account_bank
                      : "⚠️ update"
                  }}</span>
                </div>
                <div class="f_width section__value" v-else>
                  <div class="custom-select__input">
                    <select
                      class="form-control form-control-sm"
                      v-model.trim="employee.bank_account_code"
                      @change="getSelectedBank()"
                    >
                      <option
                        v-for="(bank, index) in banks"
                        :value="bank.code"
                        :key="index"
                      >
                        {{ bank.name }}
                      </option>
                    </select>
                    <div>
                      <font-awesome-icon icon="angle-down" />
                    </div>
                  </div>
                </div>
              </div>

              <div class="section__item d-flex">
                <div class="f_width section__key">Bank Account Number:</div>
                <div class="f_width section__value" v-if="!editJobPay">
                  {{ employee.bank_account_number }}
                </div>
                <div class="f_width section__value" v-else>
                  <input
                    class="form-control"
                    v-model.trim="employee.bank_account_number"
                    @input="getBankAccountName"
                  />
                </div>
              </div>

              <div class="section__item d-flex rm-padding-top">
                <div class="f_width section__key">Bank Account Name</div>
                <div class="f_width section__value" v-if="!editJobPay">
                  <span>{{ employee.bank_account_name }}</span>
                </div>
                <div
                  class="f_width section__value"
                  v-else
                  v-show="!gettingBankName"
                >
                  <input
                    class="form-control"
                    disabled
                    v-model="employee.bank_account_name"
                  />
                </div>
                <div v-show="gettingBankName">
                  <BlueLoader />
                </div>
              </div>
            </div>

            <div class="section__item section__item--pad d-flex">
              <div class="f_width section__key">PFA:</div>
              <div class="f_width section__value" v-if="!editJobPay">
                <span> {{ employee.pfa ? employee.pfa.name : "" }} </span>
              </div>
              <div class="f_width section__value" v-else>
                <div class="custom-select__input">
                  <select
                    class="form-control form-control-sm"
                    v-model.trim="employee.pfa_id"
                    @change="getPfas()"
                  >
                    <option
                      v-for="(pfa, index) in pfas"
                      :value="pfa.id"
                      :key="index"
                    >
                      {{ pfa.name }}
                    </option>
                  </select>
                  <div>
                    <font-awesome-icon icon="angle-down" />
                  </div>
                </div>
              </div>
            </div>

            <div class="section__item--border">

              <div class="section__item d-flex">
                <div class="f_width section__key">PFA Number:</div>
                <div class="f_width section__value" v-if="!editJobPay">
                  {{ employee.pfa_number }}
                </div>
                <div class="f_width section__value" v-else>
                  <input class="form-control" v-model="employee.pfa_number" />
                </div>
              </div>
            </div>

            <div class="section__item--border">
              <div class="section__item section__item--pad d-flex">
                <div class="f_width section__key">Job title</div>
                <div class="f_width section__value" v-if="!editJobPay">
                  {{ employee.designations ? employee.designations.name : "" }}
                </div>
                <div class="f_width section__value" v-else>
                  <select
                    v-model="employee.designation_id"
                    class="form-control"
                    @change="localDesignationUpdate()"
                  >
                    <option
                      v-for="designation in designations"
                      :value="designation.id"
                      :key="designation.id"
                    >
                      {{ designation.name }}
                    </option>
                  </select>

                  <div class="form-text">
                    <span v-if="!loading" @click="refreshDesignations"
                      ><svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                        class="form-text-spanIcon"
                      >
                        <path
                          d="M105.1 202.6c7.7-21.8 20.2-42.3 37.8-59.8c62.5-62.5 163.8-62.5 226.3 0L386.3 160H352c-17.7 0-32 14.3-32 32s14.3 32 32 32H463.5c0 0 0 0 0 0h.4c17.7 0 32-14.3 32-32V80c0-17.7-14.3-32-32-32s-32 14.3-32 32v35.2L414.4 97.6c-87.5-87.5-229.3-87.5-316.8 0C73.2 122 55.6 150.7 44.8 181.4c-5.9 16.7 2.9 34.9 19.5 40.8s34.9-2.9 40.8-19.5zM39 289.3c-5 1.5-9.8 4.2-13.7 8.2c-4 4-6.7 8.8-8.1 14c-.3 1.2-.6 2.5-.8 3.8c-.3 1.7-.4 3.4-.4 5.1V432c0 17.7 14.3 32 32 32s32-14.3 32-32V396.9l17.6 17.5 0 0c87.5 87.4 229.3 87.4 316.7 0c24.4-24.4 42.1-53.1 52.9-83.7c5.9-16.7-2.9-34.9-19.5-40.8s-34.9 2.9-40.8 19.5c-7.7 21.8-20.2 42.3-37.8 59.8c-62.5 62.5-163.8 62.5-226.3 0l-.1-.1L125.6 352H160c17.7 0 32-14.3 32-32s-14.3-32-32-32H48.4c-1.6 0-3.2 .1-4.8 .3s-3.1 .5-4.6 1z"
                        /></svg
                    ></span>
                    <div class="smallLoader" v-else>
                      <BlueLoader />
                    </div>
                    <p
                      v-show="!loading"
                      class="form-text-link"
                      @click="showCompanySetting"
                    >
                      Create a
                      <span class="form-text-span"> job title </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div class="text-center">
              <div v-for="(error, index) in formErrors" :key="index">
                <small style="color: red">{{ error }}</small>
              </div>
            </div>

            <div class="save-button-container" v-if="editJobPay">
              <button
                class="btn save-button"
                @click.prevent="saveJobAndPay()"
                v-show="!savingJobAndPay"
              >
                Save settings
              </button>
              <div v-show="savingJobAndPay">
                <BlueLoader />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="f_width section f_header" v-if="!pageLoading">
        <div class="d-flex justify-content-between section__head">
          <div class="d-flex align-items-center">
            <img src="./../../../assets/style/images/resume.svg" />
            <h2>Profile</h2>
          </div>

          <span>
            <a
              @click.prevent="editProfile = true"
              class="edit"
              v-if="!editProfile && profile.is_active == 1"
            >
              <font-awesome-icon icon="edit" />edit
            </a>
            <a
              @click.prevent="editProfile = false"
              class="edit"
              v-if="editProfile"
            >
              <font-awesome-icon icon="times" />close edit
            </a>
          </span>
        </div>

        <div class="card">
          <div class="card-body card__top section__body">
            <div class="section__item section__item--border d-flex">
              <div class="f_width section__key">Gender:</div>
              <div class="f_width section__value" v-if="!editProfile">
                {{ gender(profile.gender) }}
              </div>
              <div class="f_width section__value" v-else>
                <div class="custom-select__input">
                  <select v-model="profile.gender">
                    <option>Male</option>
                    <option>Female</option>
                  </select>
                  <div>
                    <font-awesome-icon icon="angle-down" />
                  </div>
                </div>
              </div>
            </div>

            <div class="section__item section__item--border d-flex">
              <div class="f_width section__key">Birthday:</div>
              <div class="f_width section__value" v-if="!editProfile">
                {{ profile.date_of_birth }}
              </div>
              <div class="f_width section__value" v-else>
                <input
                  class="form-control"
                  type="date"
                  placeholder="yyyy-mm-dd"
                  v-model="profile.date_of_birth"
                />
              </div>
            </div>
            <div class="section__item section__item--border d-flex">
              <div class="f_width section__key">Email Address:</div>
              <div class="f_width section__value" v-if="!editProfile">
                {{ profile.email }}
              </div>
              <div class="f_width section__value" v-else>
                <input
                  class="form-control"
                  v-model="profile.email"
                  disabled="disabled"
                />
              </div>
            </div>
            <div class="section__item d-flex">
              <div class="f_width section__key">Phone Number:</div>
              <div class="f_width section__value" v-if="!editProfile">
                {{ profile.phone }}
              </div>
              <div class="f_width section__value" v-else>
                <input class="form-control" v-model="profile.phone" />
              </div>
            </div>
            <div class="section__item section__item--border d-flex">
              <div class="f_width section__key">Alt Phone Number:</div>
              <div class="f_width section__value" v-if="!editProfile">
                {{ employee.alternate_phone_number }}
              </div>
              <div class="f_width section__value" v-else>
                <input
                  class="form-control"
                  v-model="employee.alternate_phone_number"
                />
              </div>
            </div>
            <div class="section__item d-flex">
              <div class="f_width section__key">Next of kin name:</div>
              <div class="f_width section__value" v-if="!editProfile">
                {{ employee.next_of_kin }}
              </div>
              <div class="f_width section__value" v-else>
                <input class="form-control" v-model="employee.next_of_kin" />
              </div>
            </div>
            <div class="section__item d-flex">
              <div class="f_width section__key">Next of kin relationship:</div>
              <div class="f_width section__value" v-if="!editProfile">
                {{ employee.kin_relationship }}
              </div>
              <div class="f_width section__value" v-else>
                <input
                  class="form-control"
                  v-model="employee.kin_relationship"
                />
              </div>
            </div>
            <div class="section__item d-flex">
              <div class="f_width section__key">Next of kin Phone:</div>
              <div class="f_width section__value" v-if="!editProfile">
                {{ employee.kin_phone }}
              </div>
              <div class="f_width section__value" v-else>
                <input class="form-control" v-model="employee.kin_phone" />
              </div>
            </div>

            <div class="save-button-container" v-if="editProfile">
              <button
                class="btn save-button"
                @click.prevent="saveProfile()"
                v-show="!savingProfile"
              >
                Save settings
              </button>
              <div v-show="savingProfile">
                <BlueLoader />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row" v-if="!pageLoading">
      <!-- beneifit start -->
      <div class="f_width section f_header" v-if="!pageLoading">
        <div class="d-flex justify-content-between section__head">
          <div class="d-flex align-items-center">
            <img src="./../../../assets/style/images/benefits.svg" />
            <h2>Benefits</h2>
          </div>

          <span>
            <a
              @click.prevent="editBenefits = true"
              class="edit"
              v-if="!editBenefits && profile.is_active == 1"
            >
              <font-awesome-icon icon="edit" />edit
            </a>
            <a
              @click.prevent="editBenefits = false"
              class="edit"
              v-if="editBenefits"
            >
              <font-awesome-icon icon="times" />close edit
            </a>
          </span>
        </div>

        <div class="card f_header">
          <div class="card-body card__bottom section__body">
            <h3>Medical Benefits</h3>

            <div class="section__item section__item--border d-flex">
              <div class="f_width section__key">Selected HMO:</div>
              <div class="f_width section__value" v-if="!editBenefits">
                {{ currentHmoProvider.provider }}
              </div>
              <div class="f_width section__value" v-else>
                <div class="custom-select__input">
                  <select
                    v-model="newHmoSubscription.provider_id"
                    @change="getHmoPlans"
                  >
                    <option
                      v-for="(hmo, index) in hmoProviders"
                      :value="hmo.id"
                      :key="index"
                    >
                      {{ hmo.provider }}
                    </option>
                  </select>
                  <div>
                    <font-awesome-icon icon="angle-down" />
                  </div>
                </div>
              </div>
            </div>

            <div class="section__item section__item--border d-flex">
              <div class="f_width section__key">Plan Type:</div>
              <div class="f_width section__value" v-if="!editBenefits">
                {{ currentHmoPlan.name }}
              </div>
              <div class="f_width section__value" v-else>
                <div class="custom-select__input">
                  <select v-model="newHmoSubscription.plan_id">
                    <option
                      v-for="(plan, index) in hmoPlans"
                      :value="plan.id"
                      :key="index"
                    >
                      {{ plan.name }}
                    </option>
                  </select>
                  <div>
                    <font-awesome-icon icon="angle-down" />
                  </div>
                </div>
              </div>
            </div>

            <div class="section__item section__item--border d-flex">
              <div class="f_width section__key">Pre existing Condition</div>
              <div class="f_width section__value" v-if="!editBenefits">
                {{ employee.pre_existing_condition }}
              </div>
              <div class="f_width section__value" v-else>
                <input
                  class="form-control"
                  v-model="employee.pre_existing_condition"
                />
              </div>
            </div>

            <div class="other-benefits">
              <h3 v-if="benefits.length">Other Benefits:</h3>

              <div v-if="!removingBenefit">
                <div
                  class="d-flex align-items-center benefit-item mb-5"
                  v-for="(benefit, index) in benefits"
                  v-bind:key="index"
                >
                  <div class="d-flex align-items-center benefit-item--green">
                    <!-- <img src="./../../../assets/style/images/spa-treatment.svg"> -->
                    <p>{{ benefit.name }}</p>
                  </div>
                  <a
                    @click.prevent="removeEmployeeBenefit(benefit)"
                    v-show="editBenefits && !removingBenefit"
                  >
                    <font-awesome-icon icon="trash-alt" size="xs" />remove
                    benefit
                  </a>
                </div>
              </div>
              <div v-else>
                <BlueLoader />
              </div>

              <div
                class="d-flex align-items-center justify-content-between other-benefit-form"
                v-if="addMoreBenefitToggle"
              >
                <h4>1. Select Benefit:</h4>

                <div class="custom-select__input" v-if="!subscribingToBenefit">
                  <select
                    v-model="newEmployeeBenefit.other_benefit_id"
                    @change="subscribeEmployeeToBenefit"
                  >
                    <option
                      v-for="(benefit, index) in allOtherBenefits"
                      :value="benefit.id"
                      :key="index"
                    >
                      {{ benefit.name }}
                    </option>
                  </select>
                  <div>
                    <font-awesome-icon icon="angle-down" />
                  </div>
                </div>

                <div v-else>
                  <BlueLoader />
                </div>
              </div>

              <div
                class="add-more"
                v-if="editBenefits && allOtherBenefits.length"
              >
                <a @click.prevent="toggleMoreBenefitForm()">
                  <font-awesome-icon icon="plus" size="xs" />add more benefits
                </a>
              </div>
            </div>

            <div class="save-button-container" v-if="editBenefits">
              <button
                class="btn save-button"
                @click.prevent="updateBenefits()"
                v-show="!savingBenefits"
              >
                Save settings
              </button>
              <div v-show="savingBenefits">
                <BlueLoader />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- benefit end -->

      <!-- document start -->
      <div class="f_width section f_header">
        <div class="d-flex justify-content-between section__head">
          <div class="d-flex align-items-center">
            <img src="./../../../assets/style/images/pdf.svg" />
            <h2>Documents</h2>
          </div>
        </div>

        <div class="card">
          <div class="card-body card__bottom section__body documents">
            <div class="row forms">
              <div class="col-sm-12">
                <div
                  class="document__upload"
                  v-for="(document, index) in documents"
                  v-bind:key="index"
                >
                  <div class="document__upload--image">
                    <img src="./../../../assets/images/file.svg" alt="file" />
                  </div>
                  <div class="document__upload--name">
                    <span>{{ document.title }}</span>
                    <p>
                      Uploaded on
                      {{ new Date(document.updated_at).toDateString() }}
                    </p>
                  </div>
                  <div class="document__upload--icons">
                    <span>
                      <a :href="document.url" target="_blank">
                        <font-awesome-icon icon="download" />
                      </a>
                    </span>
                    &nbsp;&nbsp;
                    <span
                      style="color: red"
                      @click="deleteFile(index, document.id)"
                    >
                      <font-awesome-icon icon="times" />
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div
              style="color: red; text-align: center"
              v-if="documents.length === 0"
            >
              You have not uploaded any document.
            </div>

            <div class="new-documents">
              <h1>Want to upload more documents for employee?</h1>
              <div class="new-upload">
                <label>Title of Document</label>
                <input type="text" v-model="docName" />
                <div class="upload--section">
                  <span v-show="!uploadedFile">
                    <font-awesome-icon icon="upload" />
                  </span>
                  <p v-show="!uploadedFile">upload jpg, pdf, doc</p>
                  <p v-show="uploadedFile">{{ uploadedFileName }}</p>
                  <input
                    type="file"
                    ref="doc"
                    accept=".jpg, .jpeg, .doc, .docx, .pdf"
                    @change="uploadFile"
                    v-if="!btnLoading"
                  />
                </div>
                <p v-if="uploadError">You have not chosen any document.</p>
                <p v-if="sizeError">Document must be less than 10 megabyte.</p>
                <p v-if="nameError">Please enter title of document.</p>
                <p v-if="serverError">An error occured, please try again..</p>
                <button v-if="!btnLoading" @click.prevent="sendFile">
                  Upload Document
                </button>
                <div v-if="btnLoading" class="upload--loading">
                  <WhiteLoader />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- document end -->
  </div>
</template>

<script>
import BlueLoader from "../../partials/blue-loader";
import * as types from "../../../store/constant";
import WhiteLoader from "../../partials/white-loader";

import { valueToCurrency, currencyToNumber } from "../../../util/filters";

import PageLoader from "../../partials/page-loader";

export default {
  name: "ViewEmployee",
  components: {
    BlueLoader,
    PageLoader,
    WhiteLoader,
  },

  data() {
    return {
      saveJobAndPayError: null,
      s3URL: types.S3_BUCKET_URL,
      btnLoading: false,
      nameError: false,
      sizeError: false,
      uploadedFile: false,
      serverError: false,
      docName: "",
      file: "",
      fileName: "",
      uploadedFileName: "",
      load: false,
      loading: false,
      employee: {},
      documents: [],
      profile: {},
      bank: {},
      benefits: [],
      currentHmoPlan: {},
      currentHmoProvider: {},
      pageLoading: false,
      uploadError: false,
      deActivating: false,
      emptyFields: [],
      editing: false,
      editJobPay: false,
      editProfile: false,
      editBenefits: false,
      errorMessage: null,
      gettingBankName: false,
      allOtherBenefits: [],
      addMoreBenefitToggle: false,
      newEmployeeBenefit: {
        other_benefit_id: "",
      },
      removingBenefit: false,

      hmoProviders: [],
      hmoPlans: [],
      pfas: [],

      banks: [],

      newHmoSubscription: {
        provider_id: "",
        plan_id: "",
      },

      selectedBank: {},

      documentUploadError: null,

      dataFetchError: false,
      dataSaveError: " ",
      serverErrors: null,
      dataSaveSuccess: "",

      savingProfile: false,
      savingJobAndPay: false,
      savingBenefits: false,
      subscribingToBenefit: false,

      showSalaryBreakdown: false,

      bankInfoError: null,
      compensations: [],
      deductibles: [],
      employmentLevels: [],
      designations: [],
      designation_id: "",
      level_id: "",
      manager: 1,
      employeeList: [],
      lineManager: null,
      formErrors: [],
    };
  },

  computed: {
    grossPay() {
      let values = [];

      for (let index of this.compensations) {
        if (index.value !== "") {
          values.push(index.value.toString().replace(/,/g, ""));
        }
      }

      let sum = values.reduce(
        (accumulator, currentValue) => accumulator + parseFloat(currentValue),
        0
      );

      return sum.toFixed(2);
    },

    netPay() {
      let values = [];

      for (let index of this.deductibles) {
        if (index.value !== "") {
          values.push(index.value.toString().replace(/,/g, ""));
        }
      }

      let deductibles = values.reduce(
        (accumulator, currentValue) => accumulator + parseFloat(currentValue),
        0
      );

      return deductibles > this.grossPay
        ? " -- invalid -- "
        : (parseFloat(this.grossPay) - deductibles).toFixed(2);
    },
  },

  created() {
    this.getBanks();
    this.getPfas();
  },

  methods: {
    goBack() {
      this.$router.go(-1);
    },
    showCompanySetting() {
      window.open("/settings?sec=company#company", "_blank");
    },
    refreshDesignations() {
      this.loading = true;
      this.$http
        .get(types.GET_DESIGNATION_API)
        .then((resp) => {
          this.loading = false;
          this.designations = resp.data.data;
        })
        .catch((err) => {
          this.loading = false;
          if (err.response) {
            this.dataFetchError = true;
          }
        });
    },
    getManagerLevel() {
      if (!this.$store.state.managedClient) {
        const companyId =
          this.$store.getters.currentAuthUser.employees.company_id;
        this.$http.get(`${types.COMPANY_GET_API}/${companyId}`).then((resp) => {
          this.$store.state.managedClient = resp.data.data.managed;
          this.manager = this.$store.state.managedClient;
        });
      } else {
        this.manager = this.$store.state.managedClient;
      }

      this.getOtherBenefits();
    },

    gender(gender) {
      if (!gender) return "";
      if (gender === "null") return "";
      return gender;
    },

    formatAmount(name, key) {
      if (name === "compensation") {
        let amount = this.compensations[key].value;

        if (!amount) {
          return;
        }

        if (amount.startsWith("0")) {
          amount = amount.substring(1);
        }

        if (amount.includes(".")) {
          let split = amount.split(".");

          if (split[1].length > 4) {
            this.compensations[key].value = amount.substring(
              0,
              amount.length - 1
            );

            return;
          }
        }

        // Remove commas from the amount
        amount = amount.replace(/,/g, "");

        // Check if the amount is a valid number
        this.compensations[key].value = this.isValidNumber(amount)
          ? // If it's a valid number, format it using the formatAmountStructure function
            this.formatAmountStructure(amount)
          : // If it's not a valid number, format it manually
            amount
              .substring(0, amount.length - 1)
              .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      }

      if (name === "deductible") {
        let amount = this.deductibles[key].value;

        if (!amount) {
          return;
        }

        if (amount.startsWith("0")) {
          amount = amount.substring(1);
        }

        if (amount.includes(".")) {
          let split = amount.split(".");

          if (split[1].length > 4) {
            this.deductibles[key].value = amount.substring(
              0,
              amount.length - 1
            );

            return;
          }
        }

        // Remove commas from the amount
        amount = amount.replace(/,/g, "");

        // Check if the amount is a valid number
        this.deductibles[key].value = this.isValidNumber(amount)
          ? // If it's a valid number, format it using the formatAmountStructure function
            this.formatAmountStructure(amount)
          : // If it's not a valid number, format it manually
            amount
              .substring(0, amount.length - 1)
              .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      }
    },

    manualAmountSplit(stringAmount) {
      let split = stringAmount.split(".");
      let nairaPart = split[0];
      let koboPart = split[1];
      return (
        nairaPart.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + "." + koboPart
      );
    },
    formatAmountStructure(amount) {
      let stringAmount = amount.toString();
      return stringAmount.includes(".")
        ? this.manualAmountSplit(stringAmount)
        : stringAmount.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
    isValidNumber(str) {
      // Convert the input string to a number
      let num = Number(str);
      // Check if the conversion resulted in a valid number and the string is not empty after trimming whitespace
      return !isNaN(num) && str.trim() !== "";
    },

    getEmployee() {
      this.pageLoading = true;

      this.$http
        .get(`${types.GET_EMPLOYEES_API}/${this.$route.params.id}`)
        .then((resp) => {
          this.compensations = [];
          this.deductibles = [];
          const data = resp.data.data;
          this.employee = resp.data.data;

          if (this.employee.bank_account_code && this.employee.bank_account_bank) {

            this.selectedBank.name = this.employee.bank_account_bank
            this.selectedBank.code = this.employee.bank_account_code
            
          }

          this.documents = [...data.employee_document];
          this.currentHmoPlan = data.hmo_plan;
          this.currentHmoProvider = data.hmo_provider;
          this.profile = data.user;
          // this.benefits = this.getFullBenefitData(data.other_benefit);
          for (let index of data.components) {
            if (index.type === "Compensation") {
              this.compensations.push(index);
            }
            if (index.type === "Deductible") {
              this.deductibles.push(index);
            }
          }

          for (let index of this.compensations) {
            index.value = index.value
              .toString()
              .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
          }

          for (let index of this.deductibles) {
            index.value = index.value
              .toString()
              .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
          }

          this.getDesignations();
        })
        .catch((err) => {
          this.pageLoading = false;
          if (err.response) {
            this.dataFetchError = true;
          }
        });
    },

    getFullBenefitData(benefits) {
      let benefitData = [];
      benefits.forEach((benefit) => {
        this.allOtherBenefits.forEach((otherBenefit) => {
          if (benefit.other_benefit_id == otherBenefit.id) {
            otherBenefit.other_benefit_id = benefit.id;
            benefitData.push(otherBenefit);
          }
        });
      });

      return benefitData;
    },

    activateUser() {
      this.deActivating = true;
      this.$http
        .post(types.ACTIVATE_EMPLOYEES_API, {
          employee_id: this.$route.params.id,
        })
        .then((resp) => {
          this.deActivating = false;
          this.profile.is_active = 1;
          this.getEmployee();
        })
        .catch((err) => {
          this.deActivating = true;
          if (err.response) {
            this.dataFetchError = true;
          }
        });
    },

    deactivateUser() {
      this.deActivating = true;
      this.$http
        .patch(`${types.GET_EMPLOYEES_API}/${this.$route.params.id}`)
        .then(() => {
          this.deActivating = false;
          this.profile.is_active = 0;
          this.getEmployee();
        })
        .catch((err) => {
          this.deActivating = true;
          if (err.response) {
            this.dataFetchError = true;
          }
        });
    },

    getBanks() {
      this.$http
        .get(types.BANKS_API)
        .then((resp) => {
          this.banks = resp.data.data;
          this.pageLoading = false;

          this.getEmployee();
        })
        .catch((err) => {
          if (err.response) {
            this.dataFetchError = true;
          }
          this.pageLoading = false;
        });
    },
    uploadDate(document) {
      return new Date(document.created_at).toDateString();
    },

    edit() {
      this.editing = true;
    },

    closeEdit() {
      this.editing = false;
    },

    toggleMoreBenefitForm() {
      this.addMoreBenefitToggle = true;
    },

    updateData() {
      const compensations = [];
      const deductibles = [];

      if (this.employee.designations) {
        for (let index of this.designations) {
          if (this.employee.designations.name.trim() === index.name.trim()) {
            this.employee.designation_id = index.id;
          }
        }
      }

      for (let index of this.compensations) {
        compensations.push({
          component_id: index.id,
          amount: parseInt(index.value.toString().replace(/,/g, ""), 10),
        });
      }

      for (let index of this.deductibles) {
        deductibles.push({
          component_id: index.id,
          amount: parseInt(index.value.toString().replace(/,/g, ""), 10),
        });
      }

      return {
        firstname: this.profile.firstname,
        lastname: this.profile.lastname,
        middlename: this.profile.middlename,
        staff_number: this.employee.staff_number,
        resumption_date: this.employee.resumption_date,
        company_id: this.employee.company_id,
        department_id: this.employee.department_id,
        designation_id: this.employee.designation_id,
        level_id: this.employee.level_id,
        shift_id: this.employee.shift_id,
        username: this.profile.username,
        date_of_birth: this.profile.date_of_birth,
        phone: this.profile.phone,
        alternate_phone: this.employee.alternate_phone_number,
        gender: this.profile.gender,
        address: this.profile.address,
        country: this.employee.country_id,
        state: this.employee.state_id,
        city: this.employee.city_id,
        line_manager_id: this.employee.line_manager_id,
        pre_existing_condition: this.employee.pre_existing_condition,
        tax: this.$options.filters.currencyToNumber(this.employee.tax),
        basic: this.$options.filters.currencyToNumber(this.employee.basic),
        pension: this.$options.filters.currencyToNumber(this.employee.pension),
        housing: this.$options.filters.currencyToNumber(this.employee.housing),
        transport: this.$options.filters.currencyToNumber(
          this.employee.transport
        ),
        reimbursements: this.$options.filters.currencyToNumber(
          this.employee.reimbursements
        ),
        is_active: this.profile.is_active,
        account_name: this.employee.bank_account_name,
        remittances: {
          pfa: this.employee.pfa.name,
          pfa_id: this.employee.pfa_id,
          bank_code: this.selectedBank.code,
          pfa_number: this.employee.pfa_number,
          account_number: this.employee.bank_account_number,
          account_name: this.employee.bank_account_name,
          bank_name: this.selectedBank.name,
        },
        kin_info: {
          kin_phone: this.employee.kin_phone,
          next_of_kin: this.employee.next_of_kin,
          kin_relationship: this.employee.kin_relationship,
        },
        remuneration: {
          net_pay: this.$options.filters.currencyToNumber(this.netPay),
          gross_pay: this.$options.filters.currencyToNumber(this.grossPay),
        },
        compensations: [...compensations],
        deductibles: [...deductibles],
      };
    },

    validate() {
      let updateData = this.updateData();
      function trim(updateData) {
        for (var key in updateData) {
          if (typeof updateData[key] === "string") {
            const value = updateData[key].trim();

            if (!value) {
              this.emptyFields.push(key);
            }
            updateData[key] = value;
          }

          if (typeof updateData[key] === "object") {
            trim(updateData[key]);
          }
        }
      }

      trim(updateData);
      return updateData;
    },

    updateBenefits() {
      this.subscribeEmployeeToHmo();
    },

    removeEmployeeBenefit(benefit) {
      this.removingBenefit = true;
      let data = {};

      data.employee_id = this.employee.id;
      data.other_benefit_id = benefit.id;

      this.$http
        .post(types.OTHER_BENEFTIS_REMOVAL_API, data)
        .then((resp) => {
          this.removingBenefit = false;
          this.benefits = this.benefits.filter(
            (item) => item.id !== benefit.id
          );
          this.dataSaveSuccess = resp.data.message;
        })
        .catch((err) => {
          this.removingBenefit = false;
          if (err.response) {
            this.dataSaveError = err.response.data.message;
          }
        });
    },

    getOtherBenefits() {
      this.$http
        .get(types.GET_OTHER_BENEFITS_API)
        .then((resp) => {
          this.allOtherBenefits = resp.data.data.data;
          this.getHmos();
        })
        .catch((err) => {
          if (err.response) {
            this.dataFetchError = true;
          }
          this.pageLoading = false;
        });
    },

    subscribeEmployeeToBenefit() {
      this.subscribingToBenefit = true;
      this.newEmployeeBenefit.employee_id = this.employee.id;

      this.$http
        .post(types.OTHER_BENEFTIS_SUBSCRIBE_API, this.newEmployeeBenefit)
        .then(() => {
          this.subscribingToBenefit = false;
          this.addMoreBenefitToggle = false;
          this.editBenefits = false;
          this.getEmployee();
        })
        .catch((err) => {
          this.subscribingToBenefit = false;
          if (err.response) {
            const message = err.response.data.message;
            if (typeof message === "object") {
              this.serverErrors = message;
            } else {
              this.dataSaveError = message;
            }
          }
        });
    },

    subscribeEmployeeToHmo() {
      this.serverErrors = null;
      this.dataSaveError = "";

      if (!this.newHmoSubscription.provider_id) {
        this.dataSaveError = "Please choose a provider.";
        return;
      }

      if (!this.newHmoSubscription.plan_id) {
        this.dataSaveError = "Please choose a plan.";
        return;
      }

      this.savingBenefits = true;
      this.newHmoSubscription.employee_id = this.employee.id;

      this.$http
        .post(types.HMO_SUBSCRIBE_API, this.newHmoSubscription)
        .then((resp) => {
          this.savingBenefits = false;
          const data = resp.data.data.subscription_info;
          this.currentHmoPlan = data.hmo_plan;
          this.currentHmoProvider = data.hmo_provider;
          this.dataSaveSuccess = resp.data.message;

          this.editBenefits = false;
        })
        .catch((err) => {
          this.savingBenefits = false;
          if (err.response) {
            const message = err.response.data.message;
            if (typeof message === "object") {
              this.serverErrors = message;
            } else {
              this.dataSaveError = message;
            }
          }
        });
    },

    getPfas() {
      this.$http
        .get(types.GET_PFAS)
        .then((resp) => {
          this.pfas = resp.data.data;
          // this.getEmployee();
        })
        .catch((err) => {
          if (err.response) {
            this.dataFetchError = true;
          }
          this.pageLoading = false;
        });
    },

    getHmos() {
      this.$http
        .get(types.GET_HMOS_API)
        .then((resp) => {
          this.hmoProviders = resp.data.data;
          this.getEmployee();
        })
        .catch((err) => {
          if (err.response) {
            this.dataFetchError = true;
          }
          this.pageLoading = false;
        });
    },
    getHmoPlans() {
      if (this.newHmoSubscription.provider_id) {
        this.hmoProviders.forEach((provider) => {
          if (provider.id == this.newHmoSubscription.provider_id) {
            this.hmoPlans = provider.plans;
          }
        });
      }
    },

    isJson(str) {
      try {
        JSON.parse(str);
      } catch (e) {
        return false;
      }
      return true;
    },
    localDesignationUpdate() {

      for (let designation of this.designations) {
        if (this.employee.designation_id === designation.id) {
          this.employee.designations = {name: designation.name};
        }
      }

    },

    getSelectedBank() {
      const bank = this.banks.filter((bank) => {
        if (bank.code === this.employee.bank_account_code) {
          return true;
        }
      });

      this.employee.bank_account_name = "";
      this.employee.bank_account_number = "";

      this.selectedBank = bank[0];
    },

    getBankAccountName() {
      this.bankInfoError = null;

      if (!this.employee.bank_account_number.match(/^[0-9]+$/)) {
        this.bankInfoError = "The account number must contain only numbers";
        return;
      }

      if (
        !this.selectedBank.code ||
        this.employee.bank_account_number.length !== 10
      ) {
        return;
      }

      let data = {
        account_number: this.employee.bank_account_number,
        bank_code: this.selectedBank.code,
      };

      this.gettingBankName = true;

      this.$http
        .post(types.ACCOUNTS_API, data)
        .then((resp) => {
          this.gettingBankName = false;

          if (this.isJson(resp.data.data)) {
            const data = JSON.parse(resp.data.data);
            this.employee.bank_account_name = data.account_name;
          } else {
            if (typeof resp.data.data === "string") {
              this.bankInfoError = resp.data.data;
              return;
            }

            this.employee.bank_account_name = resp.data.data.account_name;
          }
        })
        .catch((err) => {
          this.gettingBankName = false;
          if (err.response) {
            const message = err.response.data.message;
            if (typeof message === "object") {
              this.bankInfoError = message;
            } else {
              this.dataSaveError = message;
            }
          }
        });
    },

    saveJobAndPayData() {
      const compensations = [];
      const deductibles = [];

      for (let index of this.compensations) {
        compensations.push({
          component_id: index.id,
          amount: parseFloat(index.value.toString().replace(/,/g, "")),
        });
      }

      for (let index of this.deductibles) {
        deductibles.push({
          component_id: index.id,
          amount: parseFloat(index.value.toString().replace(/,/g, "")),
        });
      }

      return {
        staff_number: this.employee.staff_number,
        remittances: {
          // pfa: this.employee.pfa.name,
          // pfa_id: this.employee.pfa_id,
          bank_code: this.selectedBank.code,
          bank_name: this.selectedBank.name,
          pfa_number: this.employee.pfa_number,
          account_number: this.employee.bank_account_number,
          account_name: this.employee.bank_account_name,
        },
        compensations: [...compensations],
        deductibles: [...deductibles],
        job_title: this.employee.designation_id,
      };
    },

    saveJobAndPay() {
      this.formErrors = [];
      this.saveJobAndPayError = null;

      this.savingJobAndPay = true;

      this.employee.bank_account_bank = this.selectedBank.name;
      // this.employee.pfa.name = this.pfa?.name;

      this.$http
        .put(
          `${types.UPDATE_JOB_AND_PAY}/${this.employee.id}`,
          this.saveJobAndPayData()
        )
        .then((resp) => {
          this.savingJobAndPay = false;
          this.editJobPay = false;
        })
        .catch((err) => {
          this.savingJobAndPay = false;

          if (err.response.status === 422) {
            let errors = err.response.data.message;

            for (const key in errors) {
              if (errors.hasOwnProperty(key)) {
                const errorArray = errors[key];
                if (errorArray.length > 0) {
                  this.formErrors.push(errorArray[0]);
                }
              }
            }
          }
        });
    },

    saveProfileData() {
      return {
        gender: this.profile.gender,
        date_of_birth: this.profile.date_of_birth,
        phone: this.profile.phone,
        alternate_phone: this.employee.alternate_phone_number,
        kin_phone: this.employee.kin_phone,
        next_of_kin: this.employee.next_of_kin,
        kin_relationship: this.employee.kin_relationship,
      };
    },

    saveProfile() {
      this.savingProfile = true;
      this.serverErrors = false;
      this.$http
        .put(
          `${types.UPDATE_PROFILE_DATA}/${this.employee.id}`,
          this.saveProfileData()
        )
        .then(() => {
          this.savingProfile = false;
          this.editProfile = false;
        })
        .catch((err) => {
          this.savingProfile = false;
          this.pageLoading = false;
          if (err.response) {
            const message = err.response.data.message;
            if (typeof message === "object") {
              this.serverErrors = message;
            } else {
              this.dataSaveError = message;
            }
          }
        });
    },

    uploadFile() {
      this.fileName = this.$refs.doc;
      this.file = this.$refs.doc.files[0];
      this.uploadError = false;
      this.nameError = false;
      this.sizeError = false;
      this.serverError = false;

      if (this.file) {
        this.uploadedFileName = this.fileName.value.split("\\").pop();
        this.uploadedFile = true;
        return;
      }
      this.uploadedFile = false;
      this.uploadError = true;
    },

    sendFile() {
      this.nameError = false;
      this.btnLoading = false;
      this.sizeError = false;
      this.serverError = false;

      if (this.docName.trim() === "") {
        this.nameError = true;
        return;
      }

      if (this.file) {
        if (this.file.size > 10000000) {
          this.sizeError = true;
          return;
        }

        const userId = parseInt(this.$route.params.id);
        this.btnLoading = true;

        let formData = new FormData();
        formData.append("title", this.docName.trim());
        formData.append("document_type", "null");
        formData.append("employee_id", userId);
        formData.append("file", this.file);

        this.$http
          .post(types.EMPLOYEE_DOCUMENT_UPLOAD_API, formData)
          .then((resp) => {
            this.btnLoading = false;
            this.documents = [...resp.data.data[0].employee_documents];
            this.docName = "";
            this.uploadedFile = false;
            this.uploadedFileName = "";
          })
          .catch((err) => {
            this.serverError = true;
            this.btnLoading = false;
          });

        return;
      }
      this.uploadedFile = false;
      this.uploadError = true;
      this.btnLoading = false;
    },

    deleteFile(index, val) {
      this.networkErr = false;
      let doc = [];
      doc = [...this.documents];
      this.documents.splice(index, 1);
      this.$http
        .delete(types.ADMIN_DOCUMENT_DELETE, {
          data: {
            document_id: val,
          },
        })
        .then((resp) => {
          if (resp.data.data.employee_documents.length !== 0) {
            doc = [];
          }
        })
        .catch((err) => {
          this.documents = [...doc];
        });
    },

    getEmploymentLevels() {
      this.$http
        .get(types.EMPLOYMENT_LEVEL_API)
        .then((resp) => {
          this.employmentLevels = resp.data.data;
          this.getDesignations();
        })
        .catch((err) => {
          if (err.response) {
            this.dataFetchError = true;
          }
          this.pageLoading = false;
        });
    },

    getDesignations() {
      this.$http
        .get(types.GET_DESIGNATION_API)
        .then((resp) => {
          this.designations = resp.data.data;
          this.getApprovals();
        })
        .catch((err) => {
          if (err.response) {
            this.dataFetchError = true;
          }
          this.pageLoading = false;
        });
    },

    getApprovals() {
      this.$http
        .get(types.GET_ALL_EMPLOYEES_API)
        .then((resp) => {
          const data = resp.data.data;
          this.employeeList = [...data];
          this.pageLoading = false;

          if (this.employee.line_manager_id) {
            for (let index = 0; index < this.employeeList.length; index++) {
              if (
                this.employee.line_manager_id ===
                this.employeeList[index].user_id
              ) {
                this.lineManager = `${this.employeeList[index].user.firstname} ${this.employeeList[index].user.lastname}`;
              }
            }
          }
        })
        .catch((err) => {
          this.errorDiv = true;
          this.errorMessage = "Server error, Please try again later.";
          this.pageLoading = false;
        });
    },
  },

  filters: {
    valueToCurrency,
    currencyToNumber,
  },
};
</script>

<style lang="scss" scoped>
$padding-left-large: 60px;
$padding-right-large: 60px;
$padding-left-medium: 30px;
$padding-right-medium: 30px;
$padding-left-small: 10px;
$padding-right-small: 10px;

.f_content {
  padding-top: 31.5px;
  padding-bottom: 100px;
  padding-left: $padding-left-large;
  padding-right: $padding-right-large;

  .back-arrow{
    height: 2rem;
    width: 2rem;
    cursor: pointer;
    margin-top: 1rem;
  }

  .alert {
    margin: 20px 0 20px 0;
    border-radius: 2px;

    > svg {
      font-size: 30px;
      margin-right: 10px;
    }
  }

  .page-loader {
    margin-top: 50px;

    > div {
      width: 55px;
      margin: auto;
    }
  }

  .deactivate {
    width: 150px;
    font-size: 10px;
    margin: 10px 0 30px 0;
    background-color: #5099de;
    border: none;
    overflow: hidden;
  }

  .deactivate:hover {
    background-color: #5099de;
  }

  .deactivate-loader {
    margin-top: 10px;
    width: 150px;
  }

  .rm-padding-top {
    padding-top: 0 !important;
  }

  .data-fetch-error {
    margin-top: 40px;
    margin-bottom: 20px;
    text-align: center;
    color: red;
    font-size: 0.938vw;
    font-style: italic;

    p {
      margin: 0;
      margin-top: -60px;
      margin-left: 15px;
      padding-bottom: 10px;
    }

    p::first-letter {
      text-transform: uppercase;
    }
  }

  .success {
    margin-top: 10px;
    margin-bottom: 50px;
    color: green;
    font-size: 0.938vw;
    font-style: italic;

    p {
      margin-bottom: 0;
      text-align: center;
    }
  }

  .error {
    margin-top: -30px;
    margin-bottom: 50px;
    text-align: center;
    color: red;
    font-size: 0.938vw;
    font-style: italic;

    p {
      margin: 0;
      padding-bottom: 10px;
    }

    > div {
      padding-bottom: 10px;
    }
  }

  input,
  input:focus {
    outline: none;
  }

  .form-control {
    box-shadow: none !important;
    border-radius: 0;
    // width: 188px;
    height: 35px;
    font-size: 12px;
    border: solid 1px #777777;
    background-color: #ffffff;
  }

  a {
    text-decoration: none;
  }

  * {
    font-family: Nunito;
  }

  .employee-name {
    font-family: Nunito;
    font-size: 12px;
    font-weight: 200;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.67;
    letter-spacing: normal;
    text-align: left;
    color: #707070;

    a:first-child {
      color: #5099de;
    }
  }

  .middle-row {
    margin-bottom: 150px;
  }

  .view-employee {
    margin-top: 15px;
    font-family: Nunito;
    font-size: 16px;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.18;
    letter-spacing: normal;
    text-align: left;
    color: #000000;
    border-bottom: 2px solid #ebe4e4;
  }

  .avatar {
    padding: 10px 0 47.5px 0;
  }

  .avatar__image {
    width: 148.5px;
    height: 149.8px;
    background-color: #ffe7bd;
    margin: auto;
    border-radius: 50%;
    padding: 10px;
    margin-bottom: 15px;
  }

  .avatar__details {
    text-align: center;
    font-family: Nunito;
    font-size: 32px;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.09;
    letter-spacing: normal;
    color: #5099de;

    h2 {
      margin: 0;
      font-size: 20px;
    }

    p {
      font-family: Nunito;
      font-size: 14px;
      font-weight: 200;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.75;
      letter-spacing: normal;
      color: #000000;
    }
  }

  .section {
    padding: 0 10px 0 10px;

    .card {
      border: none;
    }

    .card__bottom {
      min-height: 510px;
    }

    .card__top {
      min-height: 620px;
    }

    .save-button-container {
      padding: 50px 80px 50px 80px;
    }

    .save-button {
      background-color: #5099de;
      border: none;
      padding: 10px;
      font-size: 13px;
      color: #ffffff;
    }
  }

  .section__head {
    margin-bottom: 5px;

    * {
      width: auto;
    }

    h2 {
      margin-bottom: 0;
      margin-left: 7px;
      font-size: 14px;
      font-weight: 500;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.25;
      letter-spacing: normal;
      color: #000000;
    }

    img {
      width: 15px;
      height: 15px;
      object-fit: contain;
    }

    .edit {
      font-size: 12px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.67;
      letter-spacing: 0.54px;
      color: #777777;
      cursor: pointer;
    }
  }

  .section__body {
    padding: 0 30px 0 30px;
    border-radius: 2px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
    background-color: #ffffff;

    > div:last-child {
      border-bottom: none;
    }

    .salary-breakdown {
      > .info-block {
        padding-bottom: 10px;

        * {
          font-size: 12px;
        }
      }

      > .info-block:last-child {
        padding-bottom: 40px;
      }
    }

    .breakdown {
      h5 {
        font-size: 14px;
        margin-top: 30px;
        text-decoration: underline;
      }
    }

    .section__item {
      padding: 25px 0 25px 0;

      .salary-breakdown-button {
        font-family: Nunito;
        font-size: 14px;
        line-height: 2.14;
        letter-spacing: normal;
        color: #5099de;
        cursor: pointer;

        
      }

      .info-block {
        padding-bottom: 20px;
      }

      .info-block:last-child {
        padding-bottom: 0px;
      }
    }

    .section__item--border {
      border-bottom: 1px #ece5e5 solid;
    }

    .section-error {
      color: red;
      text-align: center;
      font-size: 13px;
    }

    .section__value {
      color: #5099de;
      font-size: 14px;
    }

    .section__value {
      color: #5099de;
      font-size: 14px;
    }

    .section__value_date {
      font-size: 14px;
    }

    .section__key {
      font-size: 14px;
      font-weight: 200;
      line-height: 1.67;
      color: #000000;
    }

    .section__item--pad {
      padding-bottom: 0 !important;
    }

    > h3 {
      padding-top: 30px;
      font-size: 18px;
      font-weight: 500;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.67;
      letter-spacing: normal;
      color: #000000;
    }

    .other-benefits {
      margin-top: 81.5px;
      padding-bottom: 30px;

      > h3 {
        margin-bottom: 20px;
        font-size: 18px;
        font-weight: 500;
        line-height: 1.67;
        color: #000000;
      }

      .benefit-item {
        a {
          font-size: 13px;
          color: #777777;
          padding-left: 100px;
          cursor: pointer;
        }

        p {
          font-size: 16px;
          line-height: 1.67;
          margin-left: 5px;
          margin-bottom: 0;
        }

        img {
          width: 31.8px;
          height: 28.4px;
          object-fit: contain;
        }
      }

      .benefit-item--green {
        color: #5fe3a1;
      }

      .benefit-item--blue {
        color: #5099de;
      }

      .add-more {
        margin-top: 50px;
        margin-bottom: 50px;
        border: 2px dashed #5099de;
        padding: 30px;

        a {
          cursor: pointer;
          display: block;
          font-size: 14px;
          line-height: 1.19;
          text-align: center;
          color: #000000;
        }
      }

      .other-benefit-form {
        h4 {
          margin-bottom: 0;
          font-weight: 200;
          line-height: 1.67;
          color: #000000;
          width: auto;
          font-size: 16px;
        }
      }
    }
  }

  .documents {
    padding: 0 10px 0 10px;

    .forms {
      padding-top: 30px;
      margin: 0;

      h3 {
        font-size: 15px;
        line-height: 1.2;
        text-align: center;
        color: #000000;
      }

      p {
        font-size: 10px;
        line-height: 1.2;
        text-align: center;
        color: #000000;
      }

      .card-img-top {
        width: 30px;
        height: 30px;
        float: left;
        // display: block;
        // margin-left: auto;
        // margin-right: auto;
        // margin-top: 35px;
        // width: 51.7px;
        // height: 50px;
        background-color: #f17d6b;
        margin-bottom: 10px;
      }

      hr {
        color: #c7c7c7;
        margin-top: 0px;
        margin-bottom: 10px;
      }

      .card {
        border: solid 1px #c7c7c7;
        margin-bottom: 20px;
        padding: 10px;
        background-color: #ffffff;
        height: 50px;

        .icon-box {
          padding-right: 7px;
        }
      }
    }

    .new-documents {
      margin-top: 20px;

      h1 {
        font-size: 16px;
        font-weight: 500;
        line-height: 1.67;
        text-align: center;
        color: #000000;
      }

      .new-upload {
        padding: 30px;
        text-align: center;

        > label {
          font-size: 14px;
          color: #000;
          text-align: left;
        }

        > input {
          width: 100%;
          height: 40px;
          border: 1px solid #ccc;
          outline: 0;
          padding: 0 5px;
          border-radius: 3px;
          font-size: 14px;
        }

        > button {
          width: 100%;
          background-color: #5099de;
          height: 40px;
          border: 0;
          outline: 0;
          color: #fff;
          border-radius: 3px;
          font-size: 14px;
        }

        > .upload--loading {
          width: 100%;
          background-color: #5099de;
          height: 40px;
          border: 0;
          outline: 0;
          color: #fff;
          border-radius: 3px;
          font-size: 14px;
          padding-top: 5px;
        }

        > .upload--section {
          margin: 20px 0;
          padding-top: 12px;
          height: 79.4px;
          border: dotted 1px #5099de;
          background-color: #ffffff;
          position: relative;
          border-radius: 3px;
          overflow: hidden;

          > span {
            color: #5099de;
          }

          > p {
            font-family: Nunito;
            font-size: 14px;
            font-weight: 200;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.19;
            letter-spacing: normal;
            text-align: center;
            color: #000000;
          }

          > input {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: red;
            cursor: pointer;
            opacity: 0;
          }
        }

        > p {
          color: red;
          font-size: 14px;
          font-style: italic;
        }
      }
    }
  }

  .custom-select__input {
    border-radius: 1px;
    border-radius: 0;
    // width: 188px;
    height: 35px;
    font-size: 12px;
    border: solid 1px #777777;
    background-color: #ffffff;
    overflow: hidden;
    position: relative;

    > select {
      // width: 188px;
      height: 35px;
      border: solid 1px #777777;
      background-color: transparent;
      border: 0;
      outline: 0;
      padding: 0 10px;
      text-align: left;
      -moz-appearance: none;
      -webkit-appearance: none;
      position: relative;
      z-index: 2;
      font-size: 12px;
      line-height: 1.67;
      color: #777777;

      ::-ms-expand {
        display: none;
      }
    }

    > div {
      position: absolute;
      color: #777777;
      top: 0;
      right: 0;
      width: 30px;
      height: 100%;
      text-align: center;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-items: center;
      justify-content: center;
      align-content: center;
    }
  }
}

.document__upload {
  border: solid 1px #c7c7c7;
  padding: 10px;
  margin-bottom: 10px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  align-content: center;

  .document__upload--image {
    width: 30px;
    height: 30px;

    margin-bottom: 10px;
  }

  .document__upload--name {
    width: calc(100% - 80px);
    padding: 0 10px;
    text-align: center;

    > span {
      font-family: Nunito;
      font-size: 15px;
      font-weight: 500;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.2;
      letter-spacing: normal;
      color: #000000;
    }

    > p {
      font-size: 10px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.2;
      letter-spacing: normal;
      color: #000000;
      text-align: left;
      margin: 0;
    }
  }

  .document__upload--icons {
    width: 50px;
    text-align: center;

    > span {
      cursor: pointer;

      > a {
        color: #000;
        text-decoration: none;
      }
    }
  }
}

.form-text {
  font-size: 0.8rem;
  position: relative;
}

.form-text-link {
  cursor: pointer;
  margin-left: 1.3rem;
}

.form-text-span {
  color: #5099de;
  text-decoration: underline;
}

.form-text-spanIcon {
  height: 0.8rem;
  width: 0.8rem;
  position: absolute;
  top: 0;
  left: 0;
  margin-top: 0.2rem;
}

.smallLoader {
  position: absolute;
  top: 0;
  left: 0;
}

.form-text {
  font-size: 0.8rem;
  position: relative;
}

.form-text-link {
  cursor: pointer;
  margin-left: 1.3rem;
}

.form-text-span {
  color: #5099de;
  text-decoration: underline;
}

.form-text-spanIcon {
  height: 0.8rem;
  width: 0.8rem;
  position: absolute;
  top: 0;
  left: 0;
  margin-top: 0.2rem;
}

.smallLoader {
  position: absolute;
  top: 0;
  left: 0;
}

.f_width {
  width: 50%;

  @media (max-width: 768px) {
    width: 100%;
  }
}

.f_header {
  @media (max-width: 768px) {
    margin-top: 2rem;
  }
}
</style>